module.exports = __webpack_public_path__ + "img/stories-peasy.dfc9078.svg";